import { OperatorDiscovery } from "./SdkRpc";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service OperatorDiscovery
 */
export class OperatorDiscoveryClient {
    _transport;
    typeName = OperatorDiscovery.typeName;
    methods = OperatorDiscovery.methods;
    options = OperatorDiscovery.options;
    constructor(_transport) {
        this._transport = _transport;
    }
    /**
     * @generated from protobuf rpc: discoverOperators
     */
    discoverOperators(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
//# sourceMappingURL=SdkRpc.client.js.map